import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Reports_custom_ds_get_billing_tasks_by_idsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { ids: number[] }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, LicensePlateId?: number, LocationId?: number, LotId?: number, MaterialId?: number, Notes?: string, OperationCodeId?: number, OrderId?: number, ShipmentId?: number, VendorLotId?: number, WarehouseId?: number, LicensePlate?: { LookupCode?: string }, Lot?: { LookupCode?: string }, Material?: { Description?: string, LookupCode?: string, Name?: string }, Shipment?: { LookupCode?: string }, Order?: { LookupCode?: string, OwnerReference?: string }, OperationCode?: { Name?: string }, VendorLot?: { ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string }, Location?: { Name?: string }, Warehouse?: { Name?: string }, BillingContractLine?: { Id?: number, BillingAggregationStrategy?: { Name?: string } }, Uom?: { Name?: string, Short_name?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.ids)) {
      $missingRequiredInParams.push('\'ids\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { ids: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, LicensePlateId?: number, LocationId?: number, LotId?: number, MaterialId?: number, Notes?: string, OperationCodeId?: number, OrderId?: number, ShipmentId?: number, VendorLotId?: number, WarehouseId?: number, LicensePlate?: { LookupCode?: string }, Lot?: { LookupCode?: string }, Material?: { Description?: string, LookupCode?: string, Name?: string }, Shipment?: { LookupCode?: string }, Order?: { LookupCode?: string, OwnerReference?: string }, OperationCode?: { Name?: string }, VendorLot?: { ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string }, Location?: { Name?: string }, Warehouse?: { Name?: string }, BillingContractLine?: { Id?: number, BillingAggregationStrategy?: { Name?: string } }, Uom?: { Name?: string, Short_name?: string } }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.ids)) {
      $missingRequiredInParams.push('\'ids\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { ids: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, LicensePlateId?: number, LocationId?: number, LotId?: number, MaterialId?: number, Notes?: string, OperationCodeId?: number, OrderId?: number, ShipmentId?: number, VendorLotId?: number, WarehouseId?: number, LicensePlate?: { LookupCode?: string }, Lot?: { LookupCode?: string }, Material?: { Description?: string, LookupCode?: string, Name?: string }, Shipment?: { LookupCode?: string }, Order?: { LookupCode?: string, OwnerReference?: string }, OperationCode?: { Name?: string }, VendorLot?: { ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string }, Location?: { Name?: string }, Warehouse?: { Name?: string }, BillingContractLine?: { Id?: number, BillingAggregationStrategy?: { Name?: string } }, Uom?: { Name?: string, Short_name?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.ids)) {
      $missingRequiredInParams.push('\'ids\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      ids: number[]    }) {
        if(isNil($inParams.ids)) {
          return true; 
        }
      return false;
    }
}
